import { LocationModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpi/src/ocpi-cpo-api/models/locations/location.model';
import { DisplayColumnDef } from '@tanstack/react-table';

import { EmspBoLocationListActionsCell } from './emsp-bo-location-list-actions.cell';
import { EmspBoLocationListActionsHeader } from './emsp-bo-location-list-actions.header';

export const EmspBoLocationListActionsColumn: DisplayColumnDef<
  LocationModel,
  unknown
> = {
  id: 'actions',
  enableSorting: false,
  header: EmspBoLocationListActionsHeader,
  cell: EmspBoLocationListActionsCell,
};
